import useId from '../utils/useId';
import * as React from 'react';
export const operaneonSvg = React.forwardRef(function operaneonSvgInner(
  props,
  ref,
) {
  const baseId = useId();
  const id_0 = baseId + '_0';
  const id_1 = baseId + '_1';
  const id_2 = baseId + '_2';
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        clipPath: `url(#bi_operaneon__a_${id_0})`,
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M32 0H0v32h32V0Z',
        fill: '#090F11',
      }),
      /*#__PURE__*/ React.createElement(
        'mask',
        {
          id: `bi_operaneon__b_${id_1}`,
          style: {
            maskType: 'alpha',
          },
          maskUnits: 'userSpaceOnUse',
          x: 4,
          y: 3,
          width: 24,
          height: 25,
        },
        /*#__PURE__*/ React.createElement('path', {
          d: 'M27.973 16.015c0 3.556-1.55 6.754-3.995 8.966-3.072 1.494-5.934.448-6.888-.21 3.011-.657 5.307-4.333 5.307-8.756 0-4.424-2.296-8.1-5.307-8.758.954-.657 3.816-1.703 6.888-.209 2.445 2.212 3.995 5.41 3.995 8.967Z',
          fill: '#fff',
        }),
        /*#__PURE__*/ React.createElement('path', {
          d: 'M12.05 9.23c-1.311 1.554-2.176 3.885-2.236 6.485v.568c.06 2.6.925 4.932 2.237 6.486 1.73 2.241 4.263 3.646 7.126 3.646 1.76 0 3.4-.538 4.8-1.464-2.116 1.913-4.92 3.048-7.99 3.048h-.567C9.069 27.73 4 22.47 4 16.014 4 9.38 9.367 4 15.987 4h.06c3.04 0 5.814 1.166 7.93 3.049a8.661 8.661 0 0 0-4.8-1.465c-2.863 0-5.427 1.435-7.126 3.647Z',
          fill: '#fff',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'g',
        {
          mask: `url(#bi_operaneon__b_${id_1})`,
        },
        /*#__PURE__*/ React.createElement(
          'g',
          {
            filter: `url(#bi_operaneon__c_${id_2})`,
          },
          /*#__PURE__*/ React.createElement('path', {
            d: 'M18.719 29.522c8.61 0 15.59-6.98 15.59-15.59 0-8.609-6.98-15.588-15.59-15.588s-15.59 6.98-15.59 15.589c0 8.61 6.98 15.589 15.59 15.589Z',
            fill: '#fff',
          }),
          /*#__PURE__*/ React.createElement('path', {
            d: 'M7.063 17.613c-.116-3.292 3.42-7.523 5.203-9.227l7.849 9.517c.38 2.423.616 7.403-1.487 7.94-2.628.67-6.888-.436-9.172-1.342-2.284-.907-2.248-2.774-2.393-6.889Z',
            fill: '#41CEFF',
          }),
          /*#__PURE__*/ React.createElement('path', {
            d: 'M11.117 25.192c-4.653-2.01-3.417-4.8-2.218-5.944-1.356-7.67-3.536-6.294-4.457-4.647l-1.82 9.147c1.297 2.49 5.24 7.715 10.63 8.686 5.39.971 7.364-3.614 7.678-6.028-1.332.433-5.16.796-9.813-1.214Z',
            fill: '#FF6C2E',
          }),
          /*#__PURE__*/ React.createElement('path', {
            d: 'M10.569 23.078C8.182 21.489 8.997 15.63 9.703 12.9c-7.193 11.627.789 14.341 5.68 14.245 2.945-.778 8.016-2.232 4.735-1.831-4.1.5-6.565-.251-9.549-2.236Z',
            fill: '#6369FC',
          }),
          /*#__PURE__*/ React.createElement('path', {
            d: 'M7.063 19.625c0-3.785 4.653-9.831 6.979-12.381l5.166 2.338L29.25 10.78 24.501 3.6C22.543 1.836 16.688-.326 8.93 5.14c-9.698 6.834-1.867 19.215-1.867 14.484Z',
            fill: '#fff',
          }),
          /*#__PURE__*/ React.createElement('path', {
            d: 'M21.039 19.099v-7.432c4.67-2.799 8.012 1.722 9.1 4.332l-7.106 13.523c-1.692.139-5.359.167-6.49-.834-1.13-1 .472-2.362 1.414-2.918l-1.414-.925 1.414-1.994L21.04 19.1Z',
            fill: '#fff',
          }),
        ),
      ),
    ),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'clipPath',
        {
          id: `bi_operaneon__a_${id_0}`,
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#fff',
          d: 'M0 0h32v32H0z',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_operaneon__c_${id_2}`,
          x: -2.236,
          y: -6.514,
          width: 41.402,
          height: 43.939,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 2.429,
          result: 'effect1_foregroundBlur_26637_16414',
        }),
      ),
    ),
  );
});
operaneonSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var operaneon = {
  category: 'brand',
  colorable: false,
  name: 'operaneon',
  svg: operaneonSvg,
};
